import {List} from 'immutable'

import {cleanResponse} from '../redux/apiHelper'
import {categoriesWithDisplayName} from '../../../../../lib/plan_data/category'

import {RESHAPE_CATEGORIES} from '../actions/corpMaxActionTypes'

const categoriesReducer = (state = List(), action) => {
  switch (action.type) {
    case RESHAPE_CATEGORIES:
      return categoriesWithDisplayName(cleanResponse(action.payload))
    default:
      return state
  }
}

export default categoriesReducer
